module.exports = __webpack_public_path__ + "static/media/ico_web_new.681904a5.svg";